export const convertMinutes = (num: number) => {
  let minutes = Math.floor(num / 60)
    .toString()
    .padStart(2, '0');
  let seconds = (num % 60).toString().padStart(2, '0');
  return `${minutes}:${seconds}`;
};
